import { IReward } from "api/types";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { sortRewards } from "screens/RedeemRewards/utils";
import styled from "styled-components";
import theme from "themes/simple-theme";
import CartReward from "./CartReward";
import HeaderSection from "./HeaderSection";
import RedeemSection from "./RedeemSection";

export interface ICart {
  rewards: IReward[];
  className?: string;
  children?: JSX.Element[];
  total?: number;
  pointsBalance?: number;
  rewardImageBaseUrl?: string;
  tenantId?: string;
  locationId?: string;
  removeFromCart(reward: IReward): void;
}

const Cart = styled(
  ({
    className,
    rewards,
    total = 0,
    pointsBalance,
    removeFromCart,
    rewardImageBaseUrl,
    tenantId,
    locationId
  }: ICart) => {
    const renderRewards = (cartRewards: IReward[]) => {
      if (cartRewards.length > 0) {
        return (
          <Row
            align="start"
            style={{
              minHeight: 200,
              height: "30vh",
              overflowY: "scroll"
            }}
          >
            {sortRewards(cartRewards).map((reward: IReward, i: number) => (
              <CartReward
                key={i}
                reward={reward}
                removeFromCart={removeFromCart}
                rewardImageBaseUrl={rewardImageBaseUrl}
                tenantId={tenantId}
                locationId={locationId}
              />
            ))}
          </Row>
        );
      } else {
        return (
          <Row align="center" style={{ minHeight: 200 }}>
            <Empty>Add items that you'd like to redeem</Empty>
          </Row>
        );
      }
    };

    return (
      <Col md={12} className={className}>
        <Row>
          <HeaderSection pointsBalance={pointsBalance} />
        </Row>
        {renderRewards(rewards)}
        <Row>
          <RedeemSection
            total={total}
            rewards={rewards}
            pointsBalance={pointsBalance}
          />
        </Row>
      </Col>
    );
  }
)`
  display: inline-block;
  width: 100%;
  border-radius: ${theme.global.radius};
  color: ${theme.color.primary};
  background-color: ${theme.color.secondary};
`;

const Empty = styled.div`
  width: 100%;
  font-size: 15px;
  text-align: center;
  color: ${theme.color.primary};
`;

export default Cart;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/ChooseRewards/Cart/Cart.tsx